import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// 导入翻译资源
import en from './locales/en.json'
import zhCN from './locales/zh-CN.json'
import zhTW from './locales/zh-TW.json'
import fr from './locales/fr.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'

// 语言资源配置
const resources = {
  en: {
    translation: en
  },
  'zh-CN': {
    translation: zhCN
  },
  'zh-TW': {
    translation: zhTW
  },
  fr: {
    translation: fr
  },
  ja: {
    translation: ja
  },
  ko: {
    translation: ko
  }
}

// 支持的语言列表
export const supportedLanguages = ['en', 'zh-CN', 'zh-TW', 'fr', 'ja', 'ko'] as const
export type SupportedLanguage = typeof supportedLanguages[number]

// 语言配置映射
export const languageConfig = {
  en: { name: 'English', nativeName: 'English' },
  'zh-CN': { name: 'Simplified Chinese', nativeName: '简体中文' },
  'zh-TW': { name: 'Traditional Chinese', nativeName: '繁体中文' },
  fr: { name: 'French', nativeName: 'Français' },
  ja: { name: 'Japanese', nativeName: '日本語' },
  ko: { name: 'Korean', nativeName: '한국어' }
} as const

i18n
  // 检测用户语言
  .use(LanguageDetector)
  // 传递 i18n 实例给 react-i18next
  .use(initReactI18next)
  // 初始化 i18next
  .init({
    resources,
    fallbackLng: 'en', // 默认语言
    supportedLngs: [...supportedLanguages, 'zh'], // 支持的语言列表，包含 zh 以避免警告
    nonExplicitSupportedLngs: false, // 关闭非明确支持的语言
    debug: process.env.NODE_ENV === 'development',

    // 语言检测配置
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // 转换检测到的语言代码
      convertDetectedLanguage: (lang: string) => {
        if (lang === 'zh' || lang.startsWith('zh-CN')) {
          return 'zh-CN'
        }
        if (lang.startsWith('zh-TW') || lang.startsWith('zh-HK')) {
          return 'zh-TW'
        }
        return lang
      }
    },

    interpolation: {
      escapeValue: false // React 已经默认转义了
    },

    // 命名空间配置
    defaultNS: 'translation',
    ns: ['translation']
  })

export default i18n